import { diaryByIdQueryOptions } from "@/features/diaries/api";
import { diaryHomeToDoPath, diaryHomeResultsPath } from "@/features/diaries/routes";
import { useDiaryCopy } from "@/features/i18n/diaryCopy";
import { hooks as h } from "@/hooks";
import { Outlet, createFileRoute } from "@tanstack/react-router";

const NewPage = () => {
    const { diaryId } = Route.useParams();
    const copy = useDiaryCopy();

    h.useNav([
        { label: copy.diaries, route: { to: "/diaries" } },
        {
            route: { to: diaryHomeToDoPath },
            label: copy.toDo,
            options: [
                {
                    route: { to: diaryHomeToDoPath, params: { diaryId } },
                    label: copy.toDo,
                },
                {
                    route: { to: diaryHomeResultsPath, params: { diaryId } },
                    label: copy.results,
                },
            ],
        },
    ]);

    return <Outlet />;
};

export const Route = createFileRoute("/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page")({
    component: NewPage,
    loader: async ({ context, params }) => {
        await context?.queryClient.ensureQueryData(diaryByIdQueryOptions(params.diaryId));
    },
});
